import React, { useState, useEffect } from 'react'
import Dealer from './cardsBoard/dealer'
import Player from './cardsBoard/player'
import Raise from './cardsBoard/raise'
import Turn from './cardsBoard/turn'
import River from './cardsBoard/river'
import { GameBoardContainer, RiverWrapper } from './GameBoardStyles'
import { handleResultSFX } from './helpers/playResultSounds'
import useSound from 'use-sound'
import cardClearSFX from '../../lib/assets/audio/clearCards.mp3'
import { handleCardSoundsSFX } from './helpers/playCardSounds'

function GameBoard({
  player,
  dealDealer,
  dealer,
  dealPlayer,
  raise,
  dealRaise,
  turn,
  dealTurn,
  river,
  dealRiver,
  dealOut,
  flipCard,
  showResult,
  winCombination,
  audio,
  state,
  // isFold,
  showLoader,
  startDeal,
}: any) {
  const [dealOutDealer, setdealOutDealer] = useState(false)
  const [dealOutTable, setdealOutTable] = useState(false)
  const isLose = state === 6 && dealer[0] !== 'X0'
  handleResultSFX(audio, flipCard, state, isLose)
  handleCardSoundsSFX(
    audio,
    dealOut,
    state,
    player,
    dealer,
    showLoader,
    startDeal,
    isLose,
  )

  useEffect(() => {
    if (dealOut) {
      if (dealRaise) {
        setTimeout(() => {
          setdealOutTable(true)
          setTimeout(() => {
            setdealOutDealer(true)
            setTimeout(() => {
              setdealOutDealer(false)
              setdealOutTable(false)
            }, 200)
          }, 300)
        }, 200)
      } else {
        setTimeout(() => {
          setdealOutDealer(true)
          setTimeout(() => {
            setdealOutDealer(false)
          }, 600)
        }, 200)
      }
    }
  }, [dealOut])

  return (
    <GameBoardContainer>
      <Dealer
        cardsList={dealer}
        deal={dealDealer}
        dealOut={dealOutDealer}
        flipCard={flipCard}
        showResult={showResult}
        winPositions={winCombination.slice(7, 9)}
      />
      <RiverWrapper>
        <Raise
          cardsList={raise}
          deal={dealRaise}
          dealOut={dealOutTable}
          showResult={showResult}
          winPositions={winCombination.slice(2, 5)}
        />
        <Turn
          card={turn}
          deal={dealTurn}
          dealOut={dealOutTable}
          showResult={showResult}
          winPositions={winCombination[5]}
        />
        <River
          card={river}
          deal={dealRiver}
          dealOut={dealOutTable}
          showResult={showResult}
          winPositions={winCombination[6]}
        />
      </RiverWrapper>
      <Player
        cardsList={player}
        deal={dealPlayer}
        dealOut={dealOut}
        showResult={showResult}
        winPositions={winCombination.slice(0, 2)}
      />
    </GameBoardContainer>
  )
}

export default GameBoard

// {/* <Table cardsList={raise} deal={dealRaise} dealOut={dealOut} /> */}
